import React, { useContext } from "react";
import { useSelector } from "react-redux";
import MetaProperty from "components/MetaProperties/MetaProperty";
import { ContainerContext } from "context/Container";

export default function ContainerMeta(props) {
    const block = props.block;
    const { state } = useContext(ContainerContext);
    const contentFlow = useSelector((state) => state.contentFlow);

    return (
        <div className="mb-6 space-y-6">
            {contentFlow.metaProperties[block]?.map((metaProp, index) => (
                <MetaProperty
                    key={index}
                    type={metaProp.type}
                    label={metaProp.label}
                    field={metaProp.field}
                    initialValue={
                        state.container.metaProperties.find(
                            (mp) => mp.field === metaProp.field
                        )?.value
                    }
                    nameMask="meta[{field}]"
                />
            ))}
        </div>
    );
}
